module.exports = __webpack_public_path__ + "img/tr-driver-icon.20ca35ae.svg";